import { adTagEvents, adTagTypes } from '../../../../../../../../configs';
import type { TagSheetTag } from '../../../../types';

export const DEFAULT_NEW_TAG: TagSheetTag = {
  type: adTagTypes.NON_BILLABLE,
  tagUrl: '',
  position: adTagEvents.COMPLETE,
};
